"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchReplace = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const regExp_1 = require("../../utils/regExp");
const selectors_1 = require("./selectors");
const useSearchReplace = ({ eventId }) => {
    const valueSearch = (0, react_redux_1.useSelector)((state) => (0, selectors_1.selectInputEventsSearch)(state, eventId)) || '';
    const regExp = (0, regExp_1.regExpSearchString)(valueSearch);
    const searchRegExpReplace = (0, react_1.useCallback)((text) => valueSearch.length
        ? text === null || text === void 0 ? void 0 : text.replace(regExp, (str) => `<span>${str}</span>`)
        : text, [regExp, valueSearch.length]);
    return { valueSearch, regExp, searchRegExpReplace };
};
exports.useSearchReplace = useSearchReplace;
//# sourceMappingURL=useSearchReplace.js.map